import Vue from "vue";
import Vuex from "vuex";

// Plugins
import scApiPlugin from "./plugins/ScApiPlugin";
import breakpoint from "./plugins/breakpoint";
import persistState from "./plugins/persistState";
import eventTracking from "./plugins/eventTracking";

// Modules
import facets from "./modules/facets";
import search from "./modules/search";
import ui from "./modules/ui";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    facets,
    search,
    ui,
  },
  plugins: [breakpoint, persistState, eventTracking, scApiPlugin],
});
